import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { INoRowsOverlayParams } from 'ag-grid-community';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectSubAccountId } from '../../../account-info-header/reducers';
import { TransactionsTableActions } from '../../../create-request/actions';
import { TableComponentState } from '../../types/TableComponentState';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { selectConfirmationPage, selectStandingAuthTableState } from '../../reducers';
import { NoRowsFunctionInfo } from '../../types/NoRowsFunctionInfo';
import {NoRowsMessageTemplates} from '../../utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-custom-error-standing-auth-table',
  templateUrl: './custom-error-standing-auth-table.component.html',
  styleUrls: ['./custom-error-standing-auth-table.component.scss'],
})
export class CustomErrorStandingAuthTableComponent implements OnInit, OnDestroy, INoRowsOverlayAngularComp {
  params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  };
  tableState$: Observable<TableComponentState>;
  accountId: string;
  viewTransactionStatusClicked: boolean;
  createAnotherRequestClicked: boolean;
  noRowsMessageTemplates = NoRowsMessageTemplates;
  private destroy$ = new Subject<void>();

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.tableState$ = this.store.select(selectStandingAuthTableState);

    this.store.pipe(
      takeUntil(this.destroy$),
      select(selectSubAccountId)
    ).subscribe(id => this.accountId = id);

    this.store.pipe(
      takeUntil(this.destroy$),
      select(selectConfirmationPage)
    ).subscribe(confirmationPage => {
      this.viewTransactionStatusClicked = confirmationPage.viewTransactionStatusClicked;
      this.createAnotherRequestClicked = confirmationPage.createAnotherRequestClicked
    });
  }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.unsubscribe();
  }

  agInit(params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  }): void {
    this.params = params;
  }

  refreshAccount(accountId: string): void{
    this.store.dispatch(TransactionsTableActions.refresh({ accountId: accountId }));
  }
}
